import React from 'react';

/**
 * Modale d'archivage GROUPÉ avec cascade : prévient quand des propriétaires
 * sélectionnés ont des biens actifs liés, et propose d'archiver aussi ces biens.
 */
export const ContactBulkArchiveModal = ({ open, items = [], totalSelected = 0, onClose, onArchiveAll, onArchiveContactsOnly, busy = false }) => {
  if (!open) return null;
  const totalBiens = items.reduce((n, it) => n + (it.properties?.length || 0), 0);

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/50 p-4" onClick={onClose} data-testid="bulk-archive-overlay">
      <div className="bg-white rounded-2xl shadow-2xl w-full max-w-lg max-h-[85vh] flex flex-col overflow-hidden" onClick={(e) => e.stopPropagation()} data-testid="bulk-archive-modal">
        <div className="px-5 py-4 bg-amber-50 border-b border-amber-100 flex items-start gap-3">
          <div className="w-10 h-10 rounded-full bg-amber-100 text-amber-600 flex items-center justify-center flex-shrink-0">
            <i className="bi bi-archive-fill text-lg"></i>
          </div>
          <div className="flex-1">
            <h3 className="font-bold text-slate-900 text-base">Archiver {totalSelected} contact(s)</h3>
            <p className="text-sm text-slate-600 mt-0.5">
              <span className="font-semibold">{items.length} propriétaire(s)</span> ont au total <span className="font-semibold">{totalBiens} bien(s) actif(s)</span> liés. Voulez-vous aussi les archiver ?
            </p>
          </div>
          <button onClick={onClose} className="text-slate-400 hover:text-slate-600" data-testid="bulk-archive-close"><i className="bi bi-x-lg"></i></button>
        </div>

        <div className="flex-1 overflow-y-auto px-5 py-3 space-y-3">
          {items.map((it) => (
            <div key={it.contact.id} className="border border-slate-200 rounded-lg p-3" data-testid={`bulk-archive-owner-${it.contact.id}`}>
              <p className="text-sm font-semibold text-slate-800 mb-1.5">
                {it.contact.prenom} {it.contact.nom}
                <span className="ml-2 text-xs font-normal text-slate-400">{it.properties.length} bien(s)</span>
              </p>
              <ul className="space-y-1">
                {it.properties.map((p) => (
                  <li key={p.id} className="text-xs text-slate-600 flex items-center gap-2">
                    <i className="bi bi-house-door text-slate-300"></i>
                    <a href={`/properties/${p.id}/view`} target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline truncate">{p.titre}</a>
                    <span className="text-slate-400 num">· {p.reference}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="px-5 py-4 border-t border-slate-200 flex flex-wrap items-center justify-end gap-2">
          <button onClick={onClose} disabled={busy} className="px-4 py-2 text-slate-600 hover:bg-slate-100 rounded-lg text-sm font-semibold disabled:opacity-50" data-testid="bulk-archive-cancel">Annuler</button>
          <button onClick={onArchiveContactsOnly} disabled={busy} className="px-4 py-2 bg-white border border-slate-300 hover:bg-slate-50 text-slate-700 rounded-lg text-sm font-semibold disabled:opacity-50" data-testid="bulk-archive-contacts-only">Contacts seulement</button>
          <button onClick={onArchiveAll} disabled={busy} className="px-4 py-2 bg-amber-500 hover:bg-amber-600 text-white rounded-lg text-sm font-semibold flex items-center gap-1.5 disabled:opacity-50" data-testid="bulk-archive-all">
            {busy ? <i className="bi bi-hourglass-split animate-spin"></i> : <i className="bi bi-archive"></i>}
            Tout archiver (contacts + biens)
          </button>
        </div>
      </div>
    </div>
  );
};

export default ContactBulkArchiveModal;
